<template lang="pug">
.layout
  y-dialog(v-if="showModal" v-model='showModal', scrollable='', max-width='600px' persistent)
    v-card
      v-card-title.px-4
        div.h6.basic800--text(v-if="field") {{ $t('edit_extra_info') }}
        div.h6.basic800--text(v-else) {{ $t('add_extra_info') }}
      v-divider.basic300
      v-card-text.pt-4.px-4.pb-0
        v-form(ref="extraform")
          .field-name
            p.mb-2.label.basic600--text.text-uppercase {{ $t('info.label') }}
            v-text-field(v-model='extraField.name' :placeholder="$t('info.placeholder')" background-color="basic200" height="40" outlined dense persistent-hint :rules="rules.not_empty")
          
          y-checkbox.ma-0.pa-0(v-model="extraField.send" hide-details)
            template(v-slot:label)
              div.p1.primary--text {{ $t('appear_in_whatsapp') }}
          
          .field-type.mt-6
            p.mb-2.label.basic600--text.text-uppercase {{ $t('format') }}
            v-select(v-model="extraField.type" :items="fieldTypes" item-text="text" item-value="index" background-color="basic200" height="40" outlined dense hide-details)
              template(v-slot:append)
                eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
          
          .extra-info.mt-6(v-if="fieldTypes[extraField.type].hasChoices")
            template(v-for="(choice, index) in multipleChoice")
              v-layout.mt-2
                v-text-field(v-model='multipleChoice[index]' :placeholder="'Choice '+ (index + 1)" outlined dense hide-details background-color="basic200" :rules="rules.not_empty")
                v-icon.ml-2(v-if="index == (multipleChoice.length - 1) && index != 0" size=24 color="red" @click="multipleChoice.splice(multipleChoice.length - 1, 1)") mdi-minus-circle
                v-icon.ml-2(v-if="index == (multipleChoice.length - 1)" size=24 color="success" @click="multipleChoice.push('')") mdi-plus-circle
          
          .extra-info.mt-6(v-if="fieldTypes[extraField.type].hasHint")
            p.mb-2.label.basic600--text.text-uppercase {{ $t('field_hint.label') }}
            v-textarea.mt-4(v-model='fieldHint' background-color="basic200" :placeholder="$t('field_hint.placeholder')" outlined dense persistent-hint :rules="rules.not_empty")
          
          .extra-info.mt-6(v-if="fieldTypes[extraField.type].hasMinDayBefore")
            p.mb-2.label.basic600--text.text-uppercase {{ $t('delivery_day') }}
            v-text-field(:value="$tc('min_day_before_display', fieldMinDayBefore)" background-color="basic200" height="40" outlined dense hide-details return-object readonly @click="showMinDayBeforeDialog = true")
              template(v-slot:append)
                eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            y-checkbox.mt-4.pa-0(v-if="hasBusinessHours"  v-model="fieldNoDeliveryOutsideBusinessDate" hide-details)
              template(v-slot:label)
                div.p1.primary--text {{ $t('no_delivery_outside') }}

          .extra-info.mt-6(v-if="fieldTypes[extraField.type].hasMinMaxHour") 
            .start-time
              y-dialog(v-model='start.show' width='290px')
                template(v-slot:activator='{ on }')
                  .label.basic600--text.text-uppercase.mb-2 {{ $t('start.label') }}
                  v-text-field(:value="start.time" :placeholder="$t('start.placeholder')" background-color="basic200" height="40" outlined dense :rules="rules.not_empty" readonly v-on='on')
                v-time-picker.elevation-2(v-model='fieldMinMaxHour.start_time' @change="saveStartTime()" color="textColorAccent")
            .end-time
              y-dialog(v-model='end.show' width='290px')
                template(v-slot:activator='{ on }')
                  .label.basic600--text.text-uppercase.mb-2 {{ $t('end.label') }}
                  v-text-field(:value="end.time" :placeholder="$t('end.placeholder')" background-color="basic200" height="40" outlined dense :rules="rules.not_empty" readonly v-on='on')
                v-time-picker.elevation-2(v-model='fieldMinMaxHour.end_time' @change="saveEndTime()" color="textColorAccent" :min="fieldMinMaxHour.start_time")
          
          div.mb-6

      v-card-actions
        v-spacer        
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click='addField' )
          .button-AA-small.basic100--text(v-if="field") {{ $t('update') }}
          .button-AA-small.basic100--text(v-else) {{ $t('add') }}

  .modals
    y-dialog(fill-height fluid v-model="showMinDayBeforeDialog" transition="fade-transition" scrollable persistent max-width="400px")
      v-card
        v-card-title(style="height:56px;")
          .h6.basic800--text {{ $t('insert_delivery_day') }}
        v-card-text.py-3
          v-text-field(v-model='fieldMinDayBefore' outlined dense background-color="basic200" :suffix="$tc('min_day_before_suffix', fieldMinDayBefore)" type="number" hide-details)
        v-card-actions
          v-spacer
          v-btn.mr-2.mb-2(color='textColorAccent' dark depressed height=32 @click='showMinDayBeforeDialog = false')
            .button-AA-small.basic100--text {{ $t('Done') }}

</template>

<script>
export default {
  name: 'EditWaExtraFieldDialog',
  props: ['open', 'field', 'settings'],
  data: () => ({
    showMinDayBeforeDialog: false,
    extraField: {
      name: '',
      send: false,
      type: 0,
      required: true,
      enabled: true,
    },
    selectedType: null,
    extraFields: [],
    fieldTypes: [
      { 
        index: 0,
        text: 'Text',
        value: 'text'
      },
      { 
        index: 1,
        text: 'Long Text',
        value: 'long_text',
        hasHint: true
      },
      { 
        index: 2,
        text: 'Dropdown',
        value: 'dropdown',
        hasChoices: true
      },
      { 
        index: 3,
        text: 'Checklist',
        value: 'checklist',
        hasChoices: true
      },
      { 
        index: 4,
        text: 'Radio Button',
        value: 'radiobtn',
        hasChoices: true
      },
      { 
        index: 5,
        text: 'Date',
        value: 'date'
      },
      { 
        index: 6,
        text: 'Time',
        value: 'time'
      },
      { 
        index: 7,
        text: 'Delivery Date',
        value: 'delivery_date',
        hasMinDayBefore: true
      },
      { 
        index: 8,
        text: 'Delivery Time',
        value: 'delivery_time',
        hasMinMaxHour: true
      }
      // { 
      //   index: 5,
      //   text: 'Picture or File',
      //   value: 'document'
      // }
    ],
    multipleChoice: [''],
    fieldHint: '',
    fieldMinDayBefore: 0,
    fieldNoDeliveryOutsideBusinessDate: false,
    fieldMinMaxHour: {
      start_time: null,
      end_time: null
    },
    start: {
      time: null,
      show: false
    },
    end: {
      time: null,
      show: false
    },
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  mounted () {
    if (this.field) {
      this.extraField.name = this.field.name
      this.extraField.send = this.field.send || false
      this.extraField.required = this.field.required
      this.extraField.enabled = this.field.enabled
      const selectedTypes = this.fieldTypes.filter((obj) => {
        return obj.value == this.field.type
      })
      const selectedType = selectedTypes[0]
      this.extraField.type = selectedType.index
      if (selectedType.hasChoices) {
        this.multipleChoice = this.field.choices
      }
      if (selectedType.hasHint) {
        this.fieldHint = this.field.hint
      }
      if (selectedType.hasMinDayBefore) {
        this.fieldMinDayBefore = this.field.min_day_before
        this.fieldNoDeliveryOutsideBusinessDate = this.field.no_delivery_outside_business_date
      }
      if (selectedType.hasMinMaxHour) {
        this.fieldMinMaxHour = {
          start_time: this.field.start_time,
          end_time: this.field.end_time
        }
        this.saveStartTime()
        this.saveEndTime()
      }
    }
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    hasBusinessHours () {
      if (this.settings && this.settings.business_hours && this.settings.business_hours.enabled) {
        return true
      }
      return false
    }
  },
  watch: {
    fieldMinDayBefore(val) {
      if (!val) {
        this.fieldMinDayBefore = 0
        return
      }
      this.fieldMinDayBefore = Math.abs(Math.ceil(val))
    }
  },
  methods: {
    saveStartTime () {
      this.start.time = this.formatTime(this.fieldMinMaxHour.start_time)
      this.start.show = false
    },
    saveEndTime () {
      this.end.time = this.formatTime(this.fieldMinMaxHour.end_time)
      this.end.show = false
    },
    formatTime (time24) {
      let ts = time24
      const H = + ts.substr(0, 2)
      let h = (H % 12) || 12
      h = (h < 10) ? ('0' + h) : h
      const ampm = H < 12 ? 'AM' : 'PM'
      ts = h + ':' + ts.substr(3, 2) + ampm
      return ts
    },
    addField() {
      if (!this.$refs.extraform.validate()) {
        return
      }
      const newField = {
        name: this.extraField.name,
        send: this.extraField.send,
        type: this.fieldTypes[this.extraField.type].value,
        required: true,
        enabled: true,
      }
      if (this.fieldTypes[this.extraField.type].hasChoices) {
        newField['choices'] = this.multipleChoice
      }
      if (this.fieldTypes[this.extraField.type].hasHint) {
        newField['hint'] = this.fieldHint
      }
      if (this.fieldTypes[this.extraField.type].hasMinDayBefore) {
        newField['min_day_before'] = this.fieldMinDayBefore
        newField['no_delivery_outside_business_date'] = this.fieldNoDeliveryOutsideBusinessDate
      }
      if (this.fieldTypes[this.extraField.type].hasMinMaxHour) {
        newField['start_time'] = this.fieldMinMaxHour.start_time
        newField['end_time'] = this.fieldMinMaxHour.end_time
      }
      this.$emit('added', newField)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "info": {
      "label": "Info Name",
      "placeholder": "Write extra info name here"
    },
    "field_hint": {
      "label": "Info Explaination",
      "placeholder": "Write info explainations here"
    },
    "min_day_before_display" : "Same Day | 1 Day Before | {n} Days Before",
    "min_day_before_suffix" : "Day | Day | Days",
     "start": {
      "label": "Start Hour",
      "placeholder": "Select start hour"
    },
    "end": {
      "label": "End Hour",
      "placeholder": "Select end hour"
    },
    "appear_in_whatsapp": "Appear in Whatsapp message?",
    "no_delivery_outside": "No delivery outside business day",
    "insert_delivery_day": "Insert delivery day before"
  },
  "id": {
    
    "info": {
      "label": "Nama Info",
      "placeholder": "Tulis Nama Info Tambahan di sini"
    },
    "field_hint": {
      "label": "Penjelasan Info",
      "placeholder": "Tulis penjelasan info kamu di sini"
    },
    "min_day_before_display" : "Hari yang sama | 1 Hari Sebelumnya | {n} Hari Sebelumnya",
    "min_day_before_suffix" : "Hari | Hari | Hari",
     "start": {
      "label": "Jam Mulai",
      "placeholder": "Pilih Jam Mulai"
    },
    "end": {
      "label": "Jam akhir",
      "placeholder": "Pilih Jam akhir"
    },
    "appear_in_whatsapp": "Tampilkan di Pesan Whatsapp??",
    "no_delivery_outside": "Tidak ada pengiriman di luar hari kerja",
    "insert_delivery_day": "Masukkan hari pengiriman sebelumnya"
  }
}
</i18n>
